module.exports = __webpack_public_path__ + "img/logo.6391507c.png";